import React, { useState } from "react";

/* Soft gold particles drifting upward over light surfaces. */
export default function ParticleField({ count = 50, className = "" }) {
  const [particles] = useState(() =>
    Array.from({ length: count }).map((_, i) => ({
      id: i,
      size: Math.random() * 3 + 1.5,
      top: Math.random() * 100,
      left: Math.random() * 100,
      dx: (Math.random() - 0.5) * 80,
      dy: -(Math.random() * 200 + 60),
      duration: Math.random() * 12 + 9,
      delay: Math.random() * 12,
      color: i % 5 === 0 ? "#557A66" : "#B8944F",
    }))
  );

  return (
    <div aria-hidden="true" className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}>
      {particles.map((p) => (
        <span
          key={p.id}
          className="particle"
          style={{
            width: `${p.size}px`,
            height: `${p.size}px`,
            top: `${p.top}%`,
            left: `${p.left}%`,
            background: p.color,
            boxShadow: `0 0 10px ${p.color}`,
            animationDuration: `${p.duration}s`,
            animationDelay: `${p.delay}s`,
            "--dx": `${p.dx}px`,
            "--dy": `${p.dy}px`,
          }}
        />
      ))}
    </div>
  );
}
